import {Col} from "react-bootstrap";
import {useState} from "react";
import {CyberModal} from './CyberModal.tsx'


export const ProjectCard = ({type, year_nr, semester_nr, filter, title, code, shortDescription, description, imgUrl, images}) => {
    const [isOpen, setIsOpen] = useState(false)

    // Adjust year display for HU filter (5->1, 6->2, 7->3, 8->4)
    const displayYear = filter === "hu" && year_nr >= 5 && year_nr <= 8 ? year_nr - 4 : year_nr;

    const text = `${shortDescription}\n${description}`;
    return (
        <Col size={12} sm={6} md={4}>
            <div className={`proj-imgbx${type === "stage" ? " internship" : ""}${year_nr === 0 || year_nr === "0" ? " others" : ""}`} onClick={() => setIsOpen(true)}>
                <img src={imgUrl} alt={`${title}`}/>
                <div className="proj-txtx">
                    <h4>{title}</h4>
                    {year_nr && year_nr !== "0" && year_nr !== 0 && code ? (<h5>{semester_nr ? `Semester ${semester_nr}` : `Leerjaar ${displayYear}`} - {code}</h5>) : null}
                </div>
            </div>

            <CyberModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                title={title}
                subtitle={year_nr && year_nr !== "0" && year_nr !== 0 && code ? `${semester_nr ? `Semester ${semester_nr}` : `Leerjaar ${displayYear}`} - ${code}` : null}
                carouselImages={images.map(img => img.image_url.replace(/\\/g, "/"))}
            >
                {(text && text.trim() !== "" ? text : "Kom later terug voor een beschrijving!").split('\n').map((line, index) => (
                    <span key={index}>
                        {line}
                        <br/>
                    </span>
                ))}
            </CyberModal>
        </Col>
    );
};
